import Cookies, { CookieSetOptions } from "universal-cookie";

const DEFAULT_OPTIONS: CookieSetOptions = {
  path: "/",
  secure: import.meta.env.PROD,
  sameSite: "strict" as const,
};

const cookies = new Cookies();

export const SessionAuthCookies = {
  /**
   * Get a session cookie value
   * @returns The cookie value or null if not found
   */
  get: (): string | null | undefined => {
    // Try reading from universal-cookie first
    let token = cookies.get<string>("session_auth");

    // Fallback: read directly from document.cookie if universal-cookie doesn't return it
    // This handles cases where universal-cookie might have caching issues
    if (!token && typeof document !== "undefined") {
      const cookieString = document.cookie;
      const cookies = cookieString.split(";");
      const sessionCookie = cookies.find((cookie) => cookie.trim().startsWith("session_auth="));
      if (sessionCookie) {
        token = sessionCookie.split("=")[1]?.trim();
      }
    }

    return token;
  },
  /**
   * Set a session cookie value
   * @param value The cookie value
   * @param options Optional cookie options to override defaults
   */
  set: (value: string, options?: Partial<CookieSetOptions>): void => {
    const finalOptions = { ...DEFAULT_OPTIONS, ...options };
    cookies.set("session_auth", value, finalOptions);
  },
  /**
   * Remove the session cookie
   */
  remove: (): void => {
    cookies.remove("session_auth", DEFAULT_OPTIONS);
  },
  /**
   * Get refresh token cookie value
   * @returns The refresh token value or null if not found
   */
  getRefreshToken: (): string | null | undefined => {
    return cookies.get<string>("refresh_token");
  },
  /**
   * Set refresh token cookie value
   * @param value The refresh token value
   * @param options Optional cookie options to override defaults
   */
  setRefreshToken: (value: string, options?: Partial<CookieSetOptions>): void => {
    const finalOptions = { ...DEFAULT_OPTIONS, ...options };
    cookies.set("refresh_token", value, finalOptions);
  },
  /**
   * Remove the refresh token cookie
   */
  removeRefreshToken: (): void => {
    cookies.remove("refresh_token", DEFAULT_OPTIONS);
  },
};
